import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { FORM_FIELD_COMPONENT } from '../editors/Editor';

import './CreateDialog.scss';

class CreateDialog extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    configuration: PropTypes.shape({
      createDialog: PropTypes.shape({}),
    }),
    properties: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    viewService: PropTypes.shape({
      getEditor: PropTypes.func.isRequired,
    }).isRequired,
    validateValue: PropTypes.func,
    getDefaultValues: PropTypes.func,
    open: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    configuration: undefined,
    validateValue: undefined,
    getDefaultValues: undefined,
  };

  constructor(props) {
    super(props);

    const { configuration, properties } = props;
    const createConfig = configuration && configuration.createDialog;
    this.propsByName = {};
    properties.forEach((prop) => {
      this.propsByName[prop.name] = prop;
    });
    this.state = {
      title: createConfig && createConfig.title || 'Create new object',
      properties: createConfig
          && createConfig.properties
          && createConfig.properties.map((propName) => {
            const prop = this.propsByName[propName];
            if (!prop) {
              throw new Error(`Unkown create property ${propName} in create dialog config ${JSON.stringify(createConfig)}`);
            }
            return prop;
          }),
      values: {},
      validationErrors: {},
    };
    if (!this.state.properties) {
      this.state.properties = properties;
    }
    // Initialize defaut values
    this.state = {
      ...this.state,
      ...this.getInitialStateValues(),
    };

    // Bindings
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      // Update the default values and validation errors each time the dialog is showing
      // Example for using this method for this use case can be found here:
      // https://reactjs.org/docs/react-component.html#componentdidupdate
      this.setInitialState();
    }
  }

  getInitialStateValues() {
    const { validateValue, getDefaultValues } = this.props;
    const { properties } = this.state;
    let values = getDefaultValues && getDefaultValues();
    if (!values) {
      values = {};
      properties.forEach((prop) => {
        if ((prop.type === 'integer') || (prop.type === 'number')) {
          values[prop.name] = 0;
        } else if (prop.type === 'string') {
          values[prop.name] = '';
        } else if (prop.type === 'array') {
          values[prop.name] = [];
        } else {
          values[prop.name] = {};
        }
      });
    }
    const validationErrors = {};
    Object.keys(values).forEach((key) => {
      validationErrors[key] = validateValue && validateValue(
        values[key], this.propsByName[key], {},
      );
    });
    return { values, validationErrors };
  }

  handleCancel = () => {
    this.setState(this.getInitialStateValues());
    this.props.onClose(null);
  };

  handleOk = () => {
    const { values } = this.state;
    this.setState(this.getInitialStateValues());
    this.props.onClose(values);
  };

  handleChange = name => (value) => {
    const { validateValue } = this.props;
    const eventToValue = (e) => {
      return e && e.target ? e.target.value : e;
    };
    const v = eventToValue(value);
    this.setState(prevState => ({
      values: Object.assign({}, prevState.values, { [name]: v }),
      validationErrors: Object.assign({}, prevState.validationErrors,
        { [name]: validateValue && validateValue(v, this.propsByName[name], {}) }),
    }));
  };

  setInitialState() {
    this.setState(this.getInitialStateValues());
  }

  hasErrors() {
    return !!Object.keys(this.state.validationErrors).find(key => this.state.validationErrors[key]);
  }

  render() {
    const { onClose, open, viewService } = this.props;
    const { title, properties, values, validationErrors } = this.state;
    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="create-dialog-title"
        className="grb-create-dialog"
        onClose={onClose}
        open={open}
      >
        <DialogTitle id="create-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <form className="grb-create-dialog-content">
            {properties.map((prop) => {
              const Editor = viewService.getEditor(prop.type, this.props);
              const EditorCmp = Editor.getComponent(FORM_FIELD_COMPONENT, true);
              if (!EditorCmp) {
                console.log(`No editor found for type ${prop.type}`);
                return undefined;
              }
              const value = values[prop.name];
              return (
                <EditorCmp
                  {...this.props}
                  editing
                  key={prop.name}
                  label={prop.label}
                  onChange={this.handleChange(prop.name)}
                  value={value}
                  error={validationErrors[prop.name] || ''}
                  type={prop.type}
                  property={prop}
                  form
                />
              );
            })}
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleOk} color="primary" disabled={this.hasErrors()}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CreateDialog;
